export const MILESTONE_SET_INITIAL_STATE = 'MILESTONE_SET_INITIAL_STATE';
export const MILESTONE_FIND_ALL = 'MILESTONE_FIND_ALL';
export const MILESTONE_VIEW = 'MILESTONE_VIEW';
